import React, { useEffect } from "react";
import styles from "./style.scss";

interface Props {
  list: {
    label: string;
    key: string;
    icon?: React.ReactNode;
  }[];
  onClick: (key: string) => void;
  onOutsideClick?: () => void;
}

const PulldownMenu: React.FC<Props> = ({ list, onClick, onOutsideClick }) => {
  const containerRef = React.useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (!onOutsideClick) return;

    const handleDocumentClick = (event: MouseEvent | TouchEvent) => {
      const containerNode = containerRef.current as Node | null;
      if (!containerNode) return;

      const target = event.target;
      if (
        target &&
        "nodeType" in target &&
        !containerNode.contains(target as Node)
      ) {
        onOutsideClick();
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    document.addEventListener("touchstart", handleDocumentClick);

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
      document.removeEventListener("touchstart", handleDocumentClick);
    };
  }, [onOutsideClick]);

  return (
    <ul className={styles.container} ref={containerRef}>
      {list.map(item => (
        <li key={item.key}>
          <button type="button" onClick={() => onClick(item.key)}>
            {item.icon}
            {item.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default PulldownMenu;
